module.exports = __webpack_public_path__ + "static/img/9.afa8184.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/9.png
// module id = mqZW
// module chunks = 0